import React, { useEffect, useState } from "react";
import logo from "../assets/images/logo.svg";
import logo_dark from "../assets/images/logo_dark.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "./ThemeContext";
import { useTranslation, Trans } from "react-i18next";

export default function FooterNew() {
  const { t, i18n } = useTranslation();

  //redux
  const { isAuth } = useSelector((state) => state.auth);

  const siteDoc = useSelector((state) => state.siteSetting);

  const { theme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (e, path) => {
    e.preventDefault();
    if (path === "/") {
      navigate("/");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (path.startsWith("#")) {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const element = document.querySelector(path);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      } else {
        const element = document.querySelector(path);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      navigate(path);
    }
  };

  return (
    <footer className="w-full px-4 sm:px-6 md:px-8 lg:px-[100px] pt-12 sm:pt-16 md:pt-20 lg:pt-[100px] pb-4 md:pb-6 relative bg-[#f1eeed] flex flex-col justify-start items-start gap-8 md:gap-12 overflow-hidden">
      {/* Decorative Image - Hidden on mobile */}
      <img
        className="block w-[484px] h-auto absolute bottom-0 right-0"
        src={require("../assets/images/home/img_07.png")}
        alt="Decorative"
      />

      {/* Main Content */}
      <div className="w-full flex flex-col justify-start items-start gap-4 md:gap-12 relative z-10">
        {/* Top Section */}
        <div className="w-full flex flex-col lg:flex-row justify-between items-start gap-5 md:gap-20">
          {/* Left Content */}
          <div className="w-full lg:w-1/2 flex flex-col justify-start items-start gap-3 md:gap-10">
            {/* Logo Section */}
            <div className="flex justify-start items-center gap-3">
              <img
                src={logo}
                className="img-fluid brand_logo"
                alt="Light logo"
              />
            </div>

            {/* Tagline */}
            <div className="w-full justify-center text-[#395645] text-[16px] md:text-[24px] lg:text-[32px] font-normal font-['Forum'] leading-tight">
              Trusted wealth management for generations.
            </div>
          </div>

          {/* Navigation Links */}
          <div className="w-full flex flex-col justify-between items-start gap-3 md:gap-10">
            <div className="flex flex-col md:flex-row justify-start items-start gap-2 lg:gap-6">
              {[
                { label: "Home", href: "/" },
                { label: "About Us", href: "#about" },
                { label: "Services", href: "#services" },
                { label: "Our Approach", href: "#approach" },
                { label: "Clients", href: "#clients" },
                { label: "Insights", href: "#insights" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="group flex flex-col justify-center items-start gap-1 cursor-pointer transition-all duration-300"
                >
                  <div className="flex items-center gap-2 text-[#395645] text-sm lg:text-base font-normal font-['Roobert'] group-hover:text-[#395645]/70 transition-colors duration-300">
                    {link.label}
                    <img
                      src={
                        require("../assets/images/home/right_arrow.svg").default
                      }
                      alt="Arrow"
                      className="w-4 h-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                    />
                  </div>
                  <div className="h-0.5 w-0 group-hover:w-full bg-[#395645] transition-all duration-300" />
                </Link>
              ))}
            </div>
            {/* <div className="flex justify-start items-center gap-2.5">
              <div className="justify-center">
                <span class="text-[#395645]/75 text-sm md:text-base font-normal font-['Roobert']">
                  Address:{" "}
                </span>
                <span class="text-[#395645] text-sm md:text-base font-normal font-['Roobert']">
                  3 Abbey Road, London NW8 9DD
                </span>
              </div>
            </div> */}

            {/* disclaimer */}
            <div className="w-full mt-2 text-[#395645]/75 text-xs sm:text-sm font-normal font-['Roobert'] leading-relaxed">
              <span className="font-bold">Disclaimer:</span> The information on this website is provided for general informational purposes only and does not constitute investment, legal, tax, or financial advice. Investments involve risk, including possible loss of capital, and past performance is not a reliable indicator of future results. Any references to strategies, asset classes, or investment opportunities are illustrative only and may not be suitable for all investors. Services are subject to eligibility, jurisdictional availability, and applicable regulatory requirements. Please seek independent professional advice before making any financial decision.
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="w-full lg:w-2/3 pt-4 md:pt-6 lg:pt-3 border-t border-[#585858]/25 flex flex-col sm:flex-row md:flex-wrap lg:flex-row justify-between items-start sm:items-center gap-4 md:gap-6">
          <div className="text-[#395645] text-xs sm:text-sm md:text-base font-normal font-['Roobert']">
            <Link
              to="/privacy"
              className="hover:text-[#395645]/70 transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            {" | "}
            <Link
              to="/terms"
              className="hover:text-[#395645]/70 transition-colors duration-300"
            >
              Terms and Conditions
            </Link>
          </div>
          <Link
            to="/regulatory"
            className="text-[#395645] text-xs sm:text-sm md:text-base font-normal font-['Roobert'] hover:text-[#395645]/70 transition-colors duration-300"
          >
            Regulatory Information
          </Link>
          <Link
            to="/risk-disclosure"
            className="text-[#395645] text-xs sm:text-sm md:text-base font-normal font-['Roobert'] hover:text-[#395645]/70 transition-colors duration-300"
          >
            Risk Disclosure
          </Link>
          <div className="text-[#395645] text-xs sm:text-sm md:text-base font-normal font-['Roobert']">
            © 2026 MG Asset Management. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
